module.exports = __webpack_public_path__ + "assets/img/hero_6.ed1c5b26.png";